import Grid from '@material-ui/core/Grid';
import CircularProgress from '@material-ui/core/CircularProgress';
import { createStyles, makeStyles, Theme } from '@material-ui/core';
import React from 'react';

import HeaderBar from './components/header-bar';
import FooterBar from './components/footer-bar';
import Routes from './routes';
import { baseTheme } from './theme';
import { useSelector } from 'react-redux';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    appRoot: {
      padding: theme.spacing(0),
      margin: theme.spacing(0),
    },
    headerContainer: {
      backgroundColor: theme.palette.primary.main,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
    },
    loading: {
      width: '100%',
      height: '100%',
      position: 'fixed',
      top: '0px',
      left: '0px',
      fontSize: '100px',
      padding: '17% 47%',
      zIndex: 9999,
      '&::before': {
        content: '""',
        position: 'absolute',
        top: '0px',
        left: '0px',
        width: '100%',
        height: '100%',
        backgroundColor: theme.palette.grey[800],
        opacity: '0.65',
      },
    },
  }),
);

function App() {
  const classes = useStyles(baseTheme);
  const appLoading = useSelector((state: any) => state.app.loading);

  return (
    <Grid container direction="column" className={classes.appRoot}>
      {appLoading
        ? (<div className={classes.loading}>
          <CircularProgress size={100} />
        </div>)
        : null
      }
      <Grid item className={classes.headerContainer}>
        <HeaderBar />
      </Grid>
      <Grid item className={classes.appRoot}>
        <Routes />
      </Grid>
      <Grid item className={classes.appRoot}>
        <FooterBar />
      </Grid>
    </Grid>
  );
}

export default App;
